export const API_TIMEOUT = 30_000;
export const POLLING_INTERVAL = 5_000;
export const MAX_GEOFENCES = 20;
export const MIN_GEOFENCE_RADIUS_FT = 50; // minimum geofence radius in feet
export const DEFAULT_EVENT_LOG_DAYS = 30;
export const DEFAULT_EVENT_LOG_ENTRIES = 50;
export const DEFAULT_TRACK_DAYS = 10;
export const DEFAULT_TRACK_WAYPOINTS = 200;
export const MAX_CONTACTS = 8;
export const MAX_ADMIN_CONTACTS = 5;

export const APP_NAME = 'Nautic Alert';
export const APP_DESCRIPTION = 'Vessel Monitoring Portal';
